import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moreResults: {
		id: 'backlog.backlog-content.more-results.more-results',
		defaultMessage: 'More results',
		description:
			'Label shown floating near the bottom of the backlog with a down arrow if there are more issues below the scrollable area',
	},
	downArrowIconLabel: {
		id: 'backlog.backlog-content.more-results.down-arrow-icon-label',
		defaultMessage: 'Down arrow',
		description: 'Label for the down arrow icon in the more results indicator',
	},
});
